export default __webpack_public_path__ + "static/media/close.87846861.svg";